module.exports = __webpack_public_path__ + "img/011_thumbnail.458dfd03.jpg";